import { lazy } from 'react';

const MTUploadCompanyLogo = lazy(
  () => import('./MTUploadCompanyLogo.component')
);

export default MTUploadCompanyLogo;
